module.exports = __webpack_public_path__ + "img/labmem_text_btnnext_tc.5f294c9b.png";